import angular from "angular"

angular
  .module("appModule")
  .config([
    "$httpProvider",
    "jwtOptionsProvider",
    function config($httpProvider, jwtOptionsProvider) {
      jwtOptionsProvider.config({
        tokenGetter: [
          "loginService",
          function(loginService) {
            console.log("Invoking tokenGetter...")
            const token = loginService.getToken()

            return token
          }
        ],
        unauthenticatedRedirectPath: "/login",
        whiteListedDomains: [
          // In develop
          "localhost",
          // In production
          // Allows domains like:
          // - satd-api.herokuapp.com
          // - satd-api-cuc.herokuapp.com
          // - satd-api-aum.herokuapp.com
          // - api.cuc.retencion.foris.cl
          // etc.
          /^satd-api(-[a-z]+)?\.herokuapp\.com$/i,
          /^api\.([a-z]+)?\.retencion\.foris\.cl$/i
        ],
        authPrefix: "JWT "
      })

      $httpProvider.interceptors.push("jwtInterceptor")
      $httpProvider.interceptors.push("identityAuthInterceptor")
    }
  ])
  .run([
    "authManager",
    "$rootScope",
    "$state",
    "loginService",
    "tokenRefreshService",
    function(authManager, $rootScope, $state, loginService, tokenRefreshService) {
      loginService.restoreSession()

      console.debug("Checking login state...")
      authManager.checkAuthOnRefresh()
      authManager.redirectWhenUnauthenticated()

      $rootScope.$on("$stateChangeStart", function(event, next, current) {
        // console.log('state changed', next, current);
        if (!authManager.isAuthenticated() && next.name !== "login") {
          alert("not authenticated")
          event.preventDefault()
          $state.go("login")
        }
      })

      $rootScope.$on("tokenHasExpired", function(event, token) {
        console.debug(`Token expired: ${token}`)

        if (!tokenRefreshService.isIdentityAuthMode()) {
          return
        }

        tokenRefreshService
          .refreshAccessToken()
          .then(function() {
            $rootScope.$applyAsync(function() {
              authManager.authenticate()
            })
          })
          .catch(function() {
            // identity-token-refresh already tore the session down.
          })
      })
    }
  ])
